import BaseApi from 'api/core/baseApi';
import { ENDPOINTS } from 'api/config/endpoints';

class AdminUserApi extends BaseApi {
  constructor() {
    super(ENDPOINTS.MANAGEMENT_USER);
  }
}

export default new AdminUserApi();
